<div ng-controller="searchCriteriaController as searchCtrl">
    <c-auto-form config="searchCtrl.autoFormConfig"></c-auto-form>
</div>
